import { MapInterop } from "../components/vMap/MapInterop";
declare global {
    interface Date {
        format(fmt: string): string;
    }
    interface Window {
        VGIS: any,
        vMap: MapInterop;
        pInfo: (...parameters: any[]) => void;
        pWarn: (...parameters: any[]) => void;
        pWarning: (...parameters: any[]) => void;
    }
}

Date.prototype.format = function (fmt: string) {
    var o: {
        [key: string]: number
    } = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "h+": this.getHours() % 12,
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (o.hasOwnProperty(k)) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                let ok = o[k].toString();
                let replaceContent = (RegExp.$1.length === 1)
                    ? ok :
                    (("00" + ok).substr(("" + ok).length));
                fmt = fmt.replace(RegExp.$1, replaceContent);
            }
        }
    }

    return fmt;
}

window.VGIS = {};
